import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { usersDomainConstants } from './constants/users-domain.constant';

@Injectable({
  providedIn: 'root'
})
export class DomainWhitelistService {
  userId = sessionStorage.getItem('userId');
  createDomainUrl = usersDomainConstants.DOMAIN_USER + usersDomainConstants.SLASH + this.userId + usersDomainConstants.DOMAINUSER_ACTION;
  getDomainListUrl = usersDomainConstants.DOMAIN_USER + usersDomainConstants.DOMAINUSER_ACTION;
  searchDomainURL = usersDomainConstants.DOMAIN_USER + usersDomainConstants.DOMAINUSER_ACTION + usersDomainConstants.QNS_MARK + usersDomainConstants.SEARCH_BY;
  deleteDomainURL = this.createDomainUrl + usersDomainConstants.QNS_MARK + usersDomainConstants.DELETE_BY;
  getSortUrl = usersDomainConstants.SORTBY + usersDomainConstants.SORTBY_CRD_TIME +
    usersDomainConstants.SORT_TYPE + usersDomainConstants.SORTBY_DESC;
  getDomainListUrlByDesc = usersDomainConstants.DOMAIN_USER + usersDomainConstants.DOMAINUSER_ACTION + usersDomainConstants.PAGE_NUMBER
    + usersDomainConstants.EQUALS;
  getDomainListUrlByDescAllData = usersDomainConstants.DOMAIN_USER + usersDomainConstants.DOMAINUSER_ACTION;

  constructor(private httpMethodsservice: HttpMethodsService) { }

  addNewDomainList(domainParams: string) {
    const url = this.createDomainUrl;
    return this.httpMethodsservice.post(url, domainParams)
      .pipe(map((res: any) => {
        return res;
      }
      ));
  }
  getDomainListRecord(pageNumber: number, filterString?: string) {
    let url = this.getDomainListUrlByDesc + pageNumber;
    if (filterString) {
      url = `${url}${filterString}`;
    }

    return this.httpMethodsservice.get(url)
      .pipe(map((res: any) => res));
  }
  searchEmailDomains(searchValue) {
    const searchDomainURL = this.searchDomainURL + searchValue;
    return this.httpMethodsservice.get(searchDomainURL).pipe(map((res: any) => res));
  }
  deleteEmailDomainList(values) {
    const deleteURL = this.deleteDomainURL + values;
    return this.httpMethodsservice.delete(deleteURL).pipe(map((res: any) => res));
  }
  getEmailDomainWhiteListSortBy(sortby, sorttype) {
    const sortURL = this.getDomainListUrl + usersDomainConstants.SORTBY + sortby + usersDomainConstants.SORT_TYPE + sorttype;
    return this.httpMethodsservice.get(sortURL)
      .pipe(map((res: any) =>
        res));
  }
  getAllData(filterString?: string) {
    let url = this.getDomainListUrlByDescAllData;
    if (filterString) {
      url = `${url}?${filterString}`;
    }

    return this.httpMethodsservice.get(url)
      .pipe(map((res: any) =>
        res));
  }
}
